var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionTooltipAlarmLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2648_9853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.6255C10.2973 14.5791 6.29447 14.4407 3.32404 13.2101C2.451 12.8484 1.73795 12.1228 1.89744 11.0772C1.99546 10.4347 2.48013 9.89964 2.83921 9.37719C3.30954 8.68449 3.35627 7.92886 3.35635 7.12502C3.35635 6.0908 3.63638 4.95763 4.125 4.125",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 2.61623C6.56553 1.91514 7.73272 1.5 8.99715 1.5C12.1115 1.5 14.6362 4.0184 14.6362 7.125C14.6362 7.92885 14.6829 8.68448 15.1529 9.37718C15.5117 9.89963 15.9959 10.4347 16.0938 11.0772C16.1841 11.6697 16.0817 11.9959 15.7415 12.375",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.5L1.5 1.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 14.25C6.34387 15.5439 7.55663 16.5 9 16.5C10.4434 16.5 11.6561 15.5439 12 14.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2648_9853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionTooltipAlarmLight);
export default __webpack_public_path__ + "static/media/action-tooltip-alarm-light.8d5cbfcd1cdf78904f5c6855cfba279c.svg";
export { ForwardRef as ReactComponent };